<script lang="ts">
    import { onMount } from "svelte";
    import { Help, Spinner } from "@/components";
    import CreativeGenerator from "@/components/custom/creativeGenerator/App.svelte";
    import { translate } from "@/utils/format";

    import DashboardHeader from "./components/DashboardHeader.svelte";
    import DashboardNav from "./components/DashboardNav.svelte";
    import OverviewSection from "./sections/OverviewSection.svelte";
    import ClientsSection from "./sections/ClientsSection.svelte";
    import SubscriptionsSection from "./sections/SubscriptionsSection.svelte";
    import SponsoredSection from "./sections/SponsoredSection.svelte";
    import MarketingSection from "./sections/MarketingSection.svelte";
    import PayoutsSection from "./sections/PayoutsSection.svelte";
    import ProfileSection from "./sections/ProfileSection.svelte";
    import {
        DashboardStore,
        setDashboardCtx,
    } from "./state/dashboard.svelte";
    import { SponsoredStore, setSponsoredCtx } from "./state/sponsored.svelte";

    const store = setDashboardCtx(new DashboardStore());
    setSponsoredCtx(new SponsoredStore(store));

    let openHelp = $state(false);
    let showCreativeGenerator = $state(false);

    onMount(() => {
        void store.init();
        return () => store.dispose();
    });
</script>

{#if store.loading}
    <div class="dashboard__spinner">
        <Spinner
            text={translate("LOADING_CONTENT", "Cargando tu contenido...")}
        />
    </div>
{/if}

<section class="referrals">
    <DashboardHeader
        onHelp={() => (openHelp = true)}
        onProfile={() => store.setSection("profile")}
    />

    <div class="dashLayout">
        <DashboardNav />

        <main class="dashMain">
            {#key store.section}
                <div class="dashSection">
                    {#if store.section === "overview"}
                        <OverviewSection />
                    {:else if store.section === "clients"}
                        <ClientsSection />
                    {:else if store.section === "subscriptions"}
                        <SubscriptionsSection />
                    {:else if store.section === "sponsored"}
                        <SponsoredSection />
                    {:else if store.section === "marketing"}
                        <MarketingSection />
                    {:else if store.section === "payouts"}
                        <PayoutsSection />
                    {:else if store.section === "profile"}
                        <ProfileSection />
                    {/if}
                </div>
            {/key}
        </main>
    </div>

    <div role="status" aria-live="polite">
        {#if store.activeSnackBar}
            <button
                type="button"
                class="snackbar --success"
                onclick={store.deactiveSnackbar}
            >
                {store.snackBarText}
            </button>
        {/if}
    </div>

    {#if openHelp}
        <Help onCloseHelp={() => (openHelp = false)} />
    {/if}

    {#if showCreativeGenerator}
        <CreativeGenerator
            referralLink={store.referralLink}
            partnerLogo={store.user?.logo || store.user?.image || ""}
            referralCode={store.referralCode}
            onClose={() => (showCreativeGenerator = false)}
        />
    {/if}
</section>

<style lang="scss">
    // Global on purpose: extracted sections/components share these classes.
    // Generic names (.row, .right, .badge, .button) are prefixed with .referrals in the stylesheet.
    :global {
        @import "./styles/index.scss";
    }
</style>
